(function (ng) {
    

    angular.module('readmore', []);
})(window.angular);
